module.exports = __webpack_public_path__ + "media/images/instructor-ca03689b39bb6e39ec6341ccd290bb55.jpg";